// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const WorkflowSimpleIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="WorkflowSimpleIcon" ref={forwardedRef} {...props}>
      <path d="M7 5a3 3 0 0 0 2.25 2.905V12H8a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-1.25V7.905A3.001 3.001 0 0 0 10 2a3 3 0 0 0-3 3m1.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 11.5v-3h3v3z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const WorkflowSimpleIcon = /* @__PURE__ */ Object.assign(
  WorkflowSimpleIconComponent,
  { displayName: 'WorkflowSimpleIcon' },
);
